import { useTranslation } from "react-i18next";
import { Card, Table } from "antd";
import React from "react";
import i18n from "i18next";
import dayjs from "dayjs";
import { CURRENCY } from "../../../../../constants/DeliveryConstants";
import { formatPrice } from "../../../../../functions/formatters";
import utils from "../../../../../utils";

const tableColumns = [
  {
    title: i18n.t("name"),
    dataIndex: "name",
    render: (_, record) => record.farmorderCustomerName,
  },
  {
    title: i18n.t("date"),
    dataIndex: "date",
    render: (_, record) => <span>{dayjs(record.farmorderDeliveryDate, "YYYY-MM-DD").format("DD-MM-YYYY")}</span>,
  },
  {
    title: i18n.t("items"),
    dataIndex: "userShoppingCart",
    render: (_, record) => <span>{record.userShoppingCart.length}</span>,
  },
  {
    title: i18n.t("total"),
    dataIndex: "amount",
    render: (_, record) => (
      <span className="font-weight-semibold text-nowrap">{CURRENCY + formatPrice(record.totalAmount)}</span>
    ),
    sorter: (a, b) => utils.antdTableSorter(a, b, "amount"),
  },
];

const BestOrder = ({ data }) => {
  const { t } = useTranslation();
  return (
    <Card title={t("biggest_sales")}>
      <span className="text-muted">{data.readableDateRange}</span>
      <Table
        showSorterTooltip={false}
        pagination={false}
        columns={tableColumns}
        dataSource={data.bestOrders}
        rowKey="id"
        scroll={{ x: 100 }}
        style={{ marginTop: 10 }}
      />
    </Card>
  );
};

export default BestOrder;
